import { render, staticRenderFns } from "./DefaultPanelLayout.vue?vue&type=template&id=7d10c4ba&scoped=true"
import script from "./DefaultPanelLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultPanelLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultPanelLayout.vue?vue&type=style&index=0&id=7d10c4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10c4ba",
  null
  
)

export default component.exports